import { ObjectDataset } from "@tblabs/storage";
import { JobOffer } from "../Models/JobOffer";
import { Repo } from "./Repo";


export class OffersRepo extends Repo<JobOffer>
{
    constructor(_repo: ObjectDataset<JobOffer>)
    {
        super(_repo);
    }
}
